export const NotificationType = {
    none: 'none',
    link: 'link',
    text: 'text',
    table: 'table',
};
